<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .ctas {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: utils.in_rem(8px);

    overflow: auto;
  }
</style>

<script>
  // Svelte
  import { getContext } from "svelte";
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import AddManualToDoCta from "./AddManualToDoCta.svelte";
  import AddToCampaignCta from "./AddToCampaignCta.svelte";
  import AddToContactsCta from "./AddToContactsCta.svelte";
  import CallDropdownCta from "./CallDropdownCta.svelte";
  import LogActivityCta from "./LogActivityCta.svelte";
  import SendSmsCta from "./SendSmsCta.svelte";
  import SendWhatsappButtonCta from "./SendWhatsappButtonCta.svelte";
  // Context
  import { CONTACT_CTAS_CONTEXT } from "./context";
  import AddToProjectCta from "./AddToProjectCta.svelte";
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";

  const { candidateStore } = getContext(CONTACT_CTAS_CONTEXT);

  // Decide which CTAs to show
  export let callDropdownCta;
  export let sendWhatsappButtonCta;
  export let sendSmsCta;
  export let logActivityCta;
  export let addToContactsCta;
  export let addToCampaignCta;
  export let addToProjectCta;
  export let addManualToDoCta;

  // Optional prop to track where the CTAs are being used
  // Currently only used for AddToContactsCta from the Search page
  export let actionedFrom = null;

  export let style = "";
</script>

{#if Object.keys($candidateStore || {}).length}
  <div class="ctas" {style}>
    {#if callDropdownCta}
      <CallDropdownCta>
        <IconScale class="fa-regular fa-phone" size="medium" />
      </CallDropdownCta>
    {/if}
    {#if sendWhatsappButtonCta && $userStore.extensionSmsEnabled}
      <SendWhatsappButtonCta>
        <IconScale class="fa-brands fa-whatsapp" size="medium" />
      </SendWhatsappButtonCta>
    {/if}
    {#if sendSmsCta}
      <SendSmsCta>
        <IconScale class="fa-regular fa-sms" size="medium" />
      </SendSmsCta>
    {/if}
    {#if logActivityCta}
      <LogActivityCta />
    {/if}
    {#if addToCampaignCta}
      <AddToCampaignCta />
    {/if}
    {#if addToContactsCta}
      <AddToContactsCta {actionedFrom} />
    {/if}
    {#if addToProjectCta}
      <AddToProjectCta />
    {/if}
    {#if addManualToDoCta}
      <AddManualToDoCta />
    {/if}
  </div>
{/if}
